import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Standings } from './components/Standings';
import { MlbStandings } from './components/MlbStandings';
import { Schedule } from './components/Schedule';
import {Login} from './components/Login';


import './custom.css'
import { PlayerAssignment } from './components/PlayerAssignment';
import { MvpBaseballPlayerTable } from './components/MvpBaseballPlayerTable';


export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/standings' component={Standings} />
        <Route path='/fetch-data' component={FetchData} />
        <Route path='/schedule' component={Schedule} />
        <Route path='/playerassign' component={PlayerAssignment} />
          <Route path='/mvpplayerassign' component={MvpBaseballPlayerTable} />
        <Route path='/login' component={Login} />
       </Layout>
    );
  }
}
